import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid,
  Card,
  CardContent,
  Button,
  Typography,
  Stack,
  Box,
  IconButton,
} from "@mui/material";
import { MdOutlineClear, MdOutlineFileDownload } from "react-icons/md";
import { JReports, setReportSearch } from "../../../../../app/slices/jomla/reportsSlice";
import { restoreFilters } from "../../../../../helpers/restoreFilters";
import DateRangepicker from "../../../../../helpers/dateRangePicker";
import dayjs from "dayjs";
import { SelectTeamLeader } from "../../../../../components/Selectors/SelectTeamLeader";
import { SelectJRep } from "../../../../../components/Selectors/SelectJRep";

const JPosDebtMonthly = () => {
  const dispatch = useDispatch();
  const loading = useSelector(
    (state) => state.jReports.jPosDebtMonthly.loading
  );
  const _TeamLeader = useSelector((state) => state.team.leaders);
  const _JRep = useSelector((state) => state.user.jRepList.data);

  const _SearchBody = useSelector((state) => state.jReports.searchBody.jPosDebtMonthly);
  const [search, setSearch] = useState(() =>
    restoreFilters({
    startDate: dayjs().format("YYYY-MM-01"),
    endDate: dayjs().format("YYYY-MM-DD"),
    team_leader_id: null,
    j_rep_id: null,
  }, _SearchBody)
  );
  useEffect(() => {
    dispatch(setReportSearch({ name: "jPosDebtMonthly", body: search }));
  }, [dispatch, search]);

  const handleExport = () => {
    dispatch(
      JReports.jPosDebtMonthly({
        start_date: search.startDate,
        end_date: search.endDate,
        j_rep_id: search.j_rep_id ?? null,
        team_leader_id: search.team_leader_id ?? null,
      })
    );
  };

  const handleClearFilters = () => {
    setSearch({
      startDate: dayjs().format("YYYY-MM-01"),
      endDate: dayjs().format("YYYY-MM-DD"),
      j_rep_id: null,
      team_leader_id: null,
    });
  };

  return (
    <Card>
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
              تقرير مديونية نقاط البيع الشهرية
            </Typography>
          </Grid>
          <Grid item xs={12} md={2}>
            <SelectJRep
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  j_rep_id: newValue ? newValue.id : null,
                });
              }}
              value={
                _JRep.filter((user) => user.id === search.j_rep_id)[0] ?? null
              }
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <SelectTeamLeader
              supervisor_id={"true"}
              onChange={(event, value) => {
                setSearch({
                  ...search,
                  team_leader_id: value ? value.id : null,
                });
              }}
              value={
                _TeamLeader.data?.filter(
                  (x) => x.id === search.team_leader_id
                )[0] ?? null
              }
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Stack direction="row" spacing={2} alignItems="center">
              <Box sx={{ minWidth: 300 }}>
                <DateRangepicker
                  startDate={search.startDate}
                  endDate={search.endDate}
                  handleOnChange={(searchDate) => {
                    const updatedFilter = {
                      from: dayjs(searchDate[0].startDate).format("YYYY-MM-DD"),
                      to: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                    };
                    if (
                      updatedFilter.from !== searchDate.startDate ||
                      updatedFilter.to !== searchDate.endDate
                    ) {
                      setSearch({
                        ...search,
                        startDate: dayjs(searchDate[0].startDate).format(
                          "YYYY-MM-DD"
                        ),
                        endDate: dayjs(searchDate[0].endDate).format(
                          "YYYY-MM-DD"
                        ),
                      });
                    }
                  }}
                />
              </Box>
              <IconButton
                variant="outlined"
                color="secondary"
                onClick={handleClearFilters}
              >
                <MdOutlineClear />
              </IconButton>
              <Button
                variant="contained"
                color="primary"
                startIcon={<MdOutlineFileDownload />}
                onClick={handleExport}
                disabled={loading}
                sx={{ minWidth: 130 }}
              >
                {loading ? "جاري التصدير..." : "تصدير Excel"}
              </Button>
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{
                p: 3,
                textAlign: "center",
                backgroundColor: "#f5f5f5",
                borderRadius: 2,
                border: "2px dashed #ccc",
              }}
            >
              <Typography variant="body1" color="textSecondary">
                اختر نطاق التاريخ واضغط على "تصدير Excel" لتنزيل التقرير
              </Typography>
              <Typography
                variant="caption"
                color="textSecondary"
                sx={{ mt: 1 }}
              >
                التاريخ الافتراضي: من بداية الشهر الحالي إلى اليوم
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default JPosDebtMonthly;
